export const RECHARGE_ACCOUNT = "RECHARGE_account";
export const RECHARGE_ACCOUNT_CALLBACK = "RECHARGE_accountCallback";
export const RECHARGE_PRE_AMOUNTS = "RECHARGE_predefinedAmounts";
